// extracted by mini-css-extract-plugin
export default {"wrapper":"products_wrapper__0E9H-"};